import { render, staticRenderFns } from "./QuestionRankedList.vue?vue&type=template&id=b1992c9a"
import script from "./QuestionRankedList.vue?vue&type=script&lang=js"
export * from "./QuestionRankedList.vue?vue&type=script&lang=js"
import style0 from "./QuestionRankedList.vue?vue&type=style&index=0&id=b1992c9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
